<div class="doNotPrint">
	<div class="row p-2">
		<div class="col-4">
			<label class="form-label">Settlement Amount</label>
			<input type="number" required name="amount" class="form-control" [(ngModel)]="amount" min="0" (keypress)="sharedService.isNumberKey($event)" />
		</div>
		<div class="col-4">
			<mat-slide-toggle class="mat-slide-toggle-lg" [hideIcon]="true" color="primary" [(ngModel)]="includeGuarantorContact" name="includeGuarantorContact"> Include Guarantor Phone </mat-slide-toggle>
		</div>
		@if (amount != undefined || amount > 0) {
			<div class="col-4">
				@if (dsCustomerLink != undefined && dsContactLink != undefined) {
					<button class="btn btn-dark d-block" (click)="copySignLink(dsCustomerLink, 'Customer')"><i class="fas fa-link"></i> Customer Link</button>
					<button class="btn btn-secondary d-block" (click)="copySignLink(dsContactLink, 'Guarantor')"><i class="fas fa-link"></i> Guarantor Link</button>
				} @else {
					<button class="btn btn-info" (click)="createSignLink(amount)"><i class="fas fa-link"></i> Create Link</button>
				}
			</div>
		}
	</div>
	<hr />
</div>

@if (customer() != undefined && business() != undefined && contact() != undefined) {
	<div class="print-area guarantorForm" style="font-family: 'Calibri, sans-serif'; line-height: 120%; font-size: 11pt">
		<table class="letterhead-container">
			<!-- This section replicates automatically at the top of every printed page break -->
			<thead>
				<tr>
					<td>
						<h4 class="text-center">
							<strong> {{ business().Name }}</strong>
						</h4>
						<div class="text-center">
							<strong> ({{ business().OldRegNo }})</strong>
						</div>
						<div class="text-center">
							<strong> {{ licenseFullAddress() }}</strong>
						</div>
						<div class="text-center">
							<strong> TEL: {{ license().ContactNo }}</strong>
						</div>
					</td>
				</tr>
				<tr>
					<td>
						<p>&nbsp;</p>
					</td>
				</tr>
			</thead>

			<tbody>
				<div class="print-section">
					<h4 class="text-center"><strong>SURAT JAMINAN PERIBADI</strong></h4>

					<div class="row">
						<div class="col-10"></div>
						<div class="col-2">{{ today | date: 'dd-MM-yyyy' }}</div>
					</div>

					<p>
						<strong><u>A. MAKLUMAT PEMBERI PINJAM WANG</u></strong>
					</p>

					<table class="table table-borderless">
						<tbody>
							<tr>
								<td width="30%">Nama Syarikat</td>
								<td>:</td>
								<td>{{ business().Name }}</td>
							</tr>
							<tr>
								<td width="30%">No. Lesen</td>
								<td>:</td>
								<td>{{ license().AccountNo }}</td>
							</tr>
						</tbody>
					</table>

					<p>
						<strong><u>B. MAKLUMAT PEMINJAM</u></strong>
					</p>

					<table class="table table-borderless">
						<tbody>
							<tr>
								<td width="30%">Nama Peminjam</td>
								<td>:</td>
								<td>{{ this.customer().Name }}</td>
							</tr>
							<tr>
								<td width="30%">No. Kad Pengenalan</td>
								<td>:</td>
								<td>{{ this.customer().ICNumberWithDash }}</td>
							</tr>
							<tr>
								<td width="30%">Alamat</td>
								<td>:</td>
								<td>{{ this.customer().Address }}</td>
							</tr>
							<tr>
								<td width="30%">No. Telefon</td>
								<td>:</td>
								<td>{{ this.customer().ContactNo }}</td>
							</tr>
							<tr>
								<td width="30%">Jumlah Bayaran Balik</td>
								<td>:</td>
								<td>RM {{ amount | number: '1.2-2' }}</td>
							</tr>
						</tbody>
					</table>
					<p>
						<strong
							><em
								>Nota: Jaminan ini merupakan suatu jaminan berterusan (continuing guarantee) dan akan meliputi pinjaman ini serta apa-apa pinjaman tambahan, pembaharuan, penyusunan semula atau kemudahan kredit lain yang diberikan kepada Peminjam oleh Pemberi Pinjam Wang.</em
							></strong
						>
					</p>
					<p>
						<strong><u>C. MAKLUMAT PENJAMIN</u></strong>
					</p>
					<table class="table table-borderless">
						<tbody>
							<tr>
								<td width="30%">Nama Penjamin</td>
								<td>:</td>
								<td>
									{{ contact().Name }}
								</td>
							</tr>
							<tr>
								<td width="30%">No. Kad Pengenalan</td>
								<td>:</td>
								<td>
									{{ sharedService.processICNum(contact().ICNumber) }}
								</td>
							</tr>
							<tr>
								<td width="30%">Alamat</td>
								<td>:</td>
								<td>
									{{ contact().Address }}
								</td>
							</tr>
							<tr>
								<td width="30%">No. Telefon</td>
								<td>:</td>
								<td>
									@if (includeGuarantorContact) {
										{{ contact().ContactNumber }}
									}
								</td>
							</tr>
							<tr>
								<td width="30%">Hubungan dengan Peminjam</td>
								<td>:</td>
								<td>
									{{ contact().Relation | uppercase }}
								</td>
							</tr>
						</tbody>
					</table>
					<p>
						<strong><u>D. AKUAN PENJAMIN</u></strong>
					</p>
					<p>Saya dengan ini mengaku bahawa:-</p>
					<ul style="list-style-type: disc">
						<li><span>Saya mengenali Peminjam.</span></li>
						<li><span>Saya bersetuju menjadi Penjamin secara sukarela.</span></li>
						<li><span>Saya tidak dipaksa, dipengaruhi atau diperdayakan oleh mana-mana pihak.</span></li>
						<li><span>Saya telah membaca dan memahami keseluruhan Surat Jaminan Peribadi ini.</span></li>
						<li><span>Saya memahami hak dan tanggungjawab saya sebagai Penjamin.</span></li>
						<li><span>Saya telah diberi peluang untuk bertanya sebelum menandatangani dokumen ini.</span></li>
						<li><span>Saya memahami bahawa saya boleh dikenakan tindakan undang-undang sekiranya Peminjam gagal membuat pembayaran mengikut Perjanjian Pinjaman Wang.</span></li>
						<li><span>Saya mengesahkan bahawa semua maklumat yang saya berikan adalah benar.</span></li>
					</ul>

					<div class="print-footer">
						<!-- The CSS pseudo-element injects the current calculated page number here -->
						<span class="tfoot-page-counter"> </span>
					</div>
				</div>

				<div class="print-section">
					<div class="page-break">
						<p>
							<strong><u>E. PERJANJIAN JAMINAN</u></strong>
						</p>
						<p>Saya dengan ini bersetuju menjadi Penjamin kepada pinjaman yang diberikan kepada Peminjam.</p>
						<p>Sekiranya Peminjam gagal membuat pembayaran mengikut Perjanjian Pinjaman Wang, saya <strong>bersetuju untuk bertanggungjawab</strong> sebagai Penjamin menurut syarat-syarat Surat Jaminan Peribadi ini dan undang-undang Malaysia.</p>
						<p>
							<strong><u>F. LIABILITI PENJAMIN</u></strong>
						</p>
						<p>Saya bersetuju bahawa tanggungjawab saya sebagai Penjamin adalah secara bersama dan berasingan (Joint and Several Liability) dengan Peminjam, setakat yang dibenarkan oleh undang-undang.</p>
						<p>Sekiranya berlaku kemungkiran pembayaran, Pemberi Pinjam Wang berhak mengambil tindakan undang-undang terhadap Peminjam, Penjamin atau kedua-duanya, tertakluk kepada undang-undang yang berkuat kuasa.</p>
						<p>
							<strong><u>G. KOS</u></strong>
						</p>
						<p>Sekiranya Mahkamah memerintahkan demikian atau undang-undang membenarkannya, saya bersetuju menanggung kos guaman, kos Mahkamah dan kos lain yang berkaitan.</p>

						<p>
							<strong><u>H. KEBENARAN PEMPROSESAN DATA (PDPA)</u></strong>
						</p>
						<p>
							Saya memberi kebenaran kepada <span>{{ business().Name }}</span> untuk mengumpul, menggunakan, menyimpan dan memproses data peribadi saya bagi tujuan pentadbiran pinjaman, pengurusan akaun, pemulihan hutang serta tujuan lain yang dibenarkan oleh undang-undang.
						</p>
						<p>&nbsp;</p>
						<p>
							<strong><u>I. KEBENARAN AGENSI PELAPORAN KREDIT</u></strong>
						</p>
						<p>
							Saya memahami dan bersetuju bahawa, sekiranya dibenarkan oleh undang-undang, maklumat berkaitan pinjaman atau jaminan saya boleh didedahkan kepada Agensi Pelaporan Kredit seperti <strong>CTOS</strong> atau agensi lain yang sah bagi tujuan yang dibenarkan oleh
							undang-undang.
						</p>
						<p><br /></p>
					</div>
					<div class="print-footer">
						<!-- The CSS pseudo-element injects the current calculated page number here -->
						<span class="tfoot-page-counter"></span>
					</div>
				</div>

				<div class="print-section">
					<div class="page-break">
						<p>
							<strong><u>J. PENGESAHAN RAKAMAN VIDEO</u></strong>
						</p>
						<p>Saya mengesahkan bahawa saya bersetuju untuk dirakam dalam bentuk video semasa proses peminjaman dan rakaman video tersebut dibuat secara sukarela untuk tujuan merekodkan bahawa saya:</p>
						<ul style="list-style-type: disc">
							<li><span>bersetuju menjadi Penjamin secara sukarela; dan</span></li>
							<li><span>memahami tanggungjawab saya sebagai Penjamin.</span></li>
							<li>
								<span>Saya bersetuju bahawa rakaman video tersebut boleh disimpan oleh&nbsp;</span><span>{{ business().Name }}</span
								><span>&nbsp;dan, jika perlu, digunakan sebagai bahan bukti dalam prosiding Mahkamah atau kepada pihak berkuasa yang berkenaan mengikut undang-undang.</span>
							</li>
						</ul>
						<p>
							<strong><u>K. PENGESAHAN PENJAMIN</u></strong>
						</p>
						<p>Saya mengesahkan bahawa:</p>
						<p><span>☐</span> Saya telah membaca dokumen ini.</p>
						<p><span>☐</span> Saya memahami dokumen ini.</p>
						<p><span>☐</span> Saya memahami tanggungjawab saya sebagai Penjamin.</p>
						<p><span>☐</span> Saya menandatangani dokumen ini secara sukarela.</p>
						<p><span>☐</span> Saya memahami bahawa saya boleh dikenakan tindakan undang-undang sekiranya Peminjam gagal membuat pembayaran.</p>

						<p>
							<strong><u>L. TANDATANGAN PENJAMIN DAN PEMINJAM</u></strong>
						</p>

						<table class="table table-borderless">
							<tbody>
								<tr>
									<td width="30%">Nama Penjamin</td>
									<td>:</td>
									<td>
										{{ contact().Name }}
									</td>
								</tr>
								<tr>
									<td width="30%">No. Kad Pengenalan</td>
									<td>:</td>
									<td>
										{{ sharedService.processICNum(contact().ICNumber) }}
									</td>
								</tr>
								<tr>
									<td width="30%">Tandatangan</td>
									<td>:</td>
									<td>&nbsp;</td>
									<p>&nbsp;</p>
								</tr>
								<tr>
									<td width="30%">Tarikh</td>
									<td>:</td>
									<td></td>
								</tr>
								<tr>
									<td>&nbsp;</td>
								</tr>
								<tr>
									<td width="30%">Nama Peminjam</td>
									<td>:</td>

									<td>
										{{ this.customer().Name }}
									</td>
								</tr>
								<tr>
									<td width="30%">No. Kad Pengenalan</td>
									<td>:</td>
									<td>
										{{ this.customer().ICNumberWithDash }}
									</td>
								</tr>
								<tr>
									<td width="30%">Tandatangan</td>
									<td>:</td>
									<td>
										<p>&nbsp;</p>
										<p>&nbsp;</p>
									</td>
								</tr>
								<tr>
									<td width="30%">Tarikh</td>
									<td>:</td>
									<td>&nbsp;</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="print-footer">
						<!-- The CSS pseudo-element injects the current calculated page number here -->
						<span class="tfoot-page-counter"></span>
					</div>
				</div>
			</tbody>
		</table>
	</div>
}
